<template>
    <div class="v-select">
        <div class="v-select__container" @click="selectClicked"
            :class="{ 'list-dropped': isOptionListVisible, 'checked': isChecked }">
            <p class="v-select__name"> {{ selected }}</p>
        </div>
        <Transition name="fade">
            <div v-show="isOptionListVisible" class="v-select__options">
                <template v-if="isRangeinput">
                    <template v-if="selectSet">
                        <div class="range-container">
                            <input class="range-input" v-model="firstValue" @input="inputMultipleValue()" type="number"
                                :id="selectName + selectId" :name="selectName + selectId" placeholder="значение от">
                            <div></div>
                            <input class="range-input" v-model="secondValue" @input="inputMultipleValue()" type="number"
                                :id="selectName + selectId" :name="selectName + selectId" placeholder="значение до">
                        </div>
                    </template>
                    <template v-else>
                        <input class="range-input solo-input" v-model="soloValue" @input="inputSingleValue(event)"
                            type="number" :id="selectName + selectId" :name="selectName + selectId" placeholder="значение">
                    </template>
                </template>
                <template v-else>
                    <div class="v-select__radio-container" v-for="option, number in options" :key="option">
                        <input @change="selectOption(option, $event)" :type="selectType"
                            :id="selectName + selectId + number" :name="selectName + selectId" :value="option">
                        <label :for="selectName + selectId + number">{{ option }}</label>
                    </div>
                </template>
            </div>
        </Transition>
    </div>
</template>

<script>
export default {
    name: 'v-select',
    props: {
        selectLabel: {
            type: String,
            default() {
                return 'value'
            }
        },
        selectName: {
            type: String,
            default() {
                return 'value'
            }
        },
        selectId: {
            type: Number,
            default() {
                return 0
            }
        },
        options: {
            type: Array,
            default() {
                return []
            }
        },
        selected: {
            type: String,
            default() {
                return 'Select'
            }
        },
        selectSet: {
            type: Boolean,
            default() {
                return true
            }
        }
    },
    emits: ['select'],
    data() {
        return {
            isOptionListVisible: false,
            selectedOption: this.selected,
            selectType: 'checkbox',
            selectedOptions: [],
            checkedCounter: 0,
            firstValue: '',
            secondValue: '',
            soloValue: ''
        }
    },

    computed: {
        isRangeinput() {
            if (this.options === null) {
                return true
            }
            else {
                return false
            }
        },
        isChecked() {
            if (this.checkedCounter === 0 && this.firstValue === '' && this.secondValue === '' && this.soloValue === '') {
                return false
            }
            else {
                return true
            }
        },
    },

    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOptionListVisible = false
            }
        })

        if (this.selectSet) {
            this.selectType = 'checkbox'
        } else {
            this.selectType = 'radio'
        }
    },

    beforeUnmount() {
        window.removeEventListener("click", (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOptionListVisible = false
            }
        });
    },

    methods: {
        selectClicked() {
            this.isOptionListVisible = !this.isOptionListVisible
        },
        inputSingleValue() {
            let rangeValue = {
                translation: this.selected,
                name: this.selectName,
                value: this.soloValue
            }
            this.$emit('select', rangeValue);
        },
        inputMultipleValue() {
            let rangeValue = {
                translation: this.selected,
                name: this.selectName,
                value: [
                    this.firstValue,
                    this.secondValue
                ]
            }
            if (this.firstValue == '') {
                rangeValue.value[0] = null
            }
            if (this.secondValue == '') {
                rangeValue.value[1] = null
            }
            this.$emit('select', rangeValue);
        },
        selectOption(option, event) {
            let selectedOption = {
                translation: this.selected,
                name: this.selectName,
                value: option
            }
            if (this.selectSet) {
                if (!event.target.checked) {
                    this.selectedOptions = this.selectedOptions.filter((item) => {
                        return item !== option;
                    })
                    this.checkedCounter--;
                }
                else {
                    this.selectedOptions.push(option);
                    this.checkedCounter++;
                }
                selectedOption.value = this.selectedOptions;
            }
            this.$emit('select', selectedOption);
            this.selectedOption = option
            if (!this.selectSet) {
                this.checkedCounter = 1;
                this.hideSelect();
            }
        },
        hideSelect() {
            this.isOptionListVisible = false;
        },
        checkList(array) {
            if (array.findIndex(e => e.name === this.selectName) === -1) {
                this.clear()
            };
        },
        clear() {
            this.$el.querySelectorAll("input[type='checkbox']").forEach(input => {
                input.checked = false
            })
            this.$el.querySelectorAll("input[type='radio']").forEach(input => {
                input.checked = false
            })
            this.checkedCounter = 0
            this.firstValue = ''
            this.secondValue = ''
            this.soloValue = ''
        }
    }

}
</script>

<style lang="scss">
.v-select {
    position: relative;

    &__container {
        width: 150px;
        border-radius: 15px;
        padding: 10px 16px;
        text-align: left;

        position: relative;

        cursor: pointer;

        svg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 15px;

            transition: transform .3s
        }

        &.list-dropped {
            svg {
                transform: translateY(-50%) rotate(180deg);
            }
        }
    }

    &__label {
        @extend %BODY2;
        color: $second-font-color;
    }

    &__name {
        @extend %BODY1;
        color: $font-color;
    }

    &__options {
        position: absolute;
        min-width: 150%;

        max-height: 300px;
        overflow-y: scroll;

        display: flex;
        flex-direction: column;

        left: 0;
        top: 60px;
        background: $white;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
        border-radius: 15px;
        padding: 8px;

        z-index: 5;

        &::-webkit-scrollbar {
            width: 4px;
            background-color: #f9f9fd;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: $main-color;
        }

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background-color: #f9f9fd;
        }

        span {
            display: flex;
            width: 100%;
            padding: 12px 16px;
            border-radius: 8px;

            transition: background-color .3s, color .3s;

            cursor: pointer;

            &:hover {
                background-color: $main-color-hover;
                color: $white;
            }
        }
    }

    &__radio-container {
        position: relative;

        input {
            position: absolute;
            z-index: -99;
            width: 1px;
            height: 1px;
            opacity: 0;
        }

        label {
            @extend %BODY1;
            color: $font-color;

            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 12px 16px;
            border-radius: 8px;

            position: relative;
            z-index: 2;

            cursor: pointer;

            transition: background-color .3s;

            white-space: nowrap;

            &:hover {
                background-color: $second-background-color;
            }
        }

        label::before {
            display: block;
            content: "";
            width: 20px;
            height: 20px;
            border: 2px solid $main-color;

            border-radius: 5px;

            flex-shrink: 0;

            transition: background-color 0.3s, box-shadow 0.3s;

            margin-right: 15px;
        }

        input:checked+label::before {
            border: 7px solid $main-color;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-to {
    opacity: 1;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>